import { IconButton, Menu, MenuItem } from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import { colors } from "../../constants/colors";
const UserButton = ({
  handleUserMenuOpen,
  handleUserMenuClose,
  userMenuAnchor,
  handleProfileClick,
  handleLogout,
}) => {
  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleUserMenuOpen}
        aria-controls="user-menu"
        aria-haspopup="true"
      >
        <AccountCircle />
      </IconButton>
      <Menu
        id="user-menu"
        anchorEl={userMenuAnchor}
        keepMounted
        open={Boolean(userMenuAnchor)}
        onClose={handleUserMenuClose}
      >
        <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default UserButton;
